import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import {
  checkEighteen,
  brazillianDateToISO,
  checkBrazilianDateFormat,
} from '../../utils/utils';

export function OverEighteenValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    const validAge = new Date(brazillianDateToISO(value)) <= checkEighteen(new Date());

    return !checkBrazilianDateFormat(value) || !validAge
      ? {
          overEighteen: {
            valid: false,
          },
        }
      : null;
  };
}
